import {ChangeEvent, FC, useState, useRef, useEffect} from 'react'
import {KTCard} from '../../../../../../_metronic/helpers'
import {Button} from '../../Button'
import {ModalErrorTable, ModalErrorList} from '../../Modal'
import {TableResumen} from '../../../../features/central/model'
import {ShowSnackBar} from '../../../../util/functions'
import Poppup from '../../Poppup'
interface Props {
  serviceTemplate?: () => void
  handleSendService?: (data: any) => {}
  textData?: string
  textData1?: string
  showModalList?: boolean
  title?: string
}
const FormMasive: FC<Props> = ({
  serviceTemplate = () => {},
  handleSendService = () => {},
  textData1 = '',
  textData = '',
  showModalList = false,
  title = '',
}) => {
  const [file, setFile] = useState<File | null>(null)
  const [fileName, setFileName] = useState<File | null>(null)
  const [error, setError] = useState('')
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<TableResumen[] | any>([])
  const [response1, setResponse1] = useState<TableResumen[] | any>([])
  const [intervalId, setIntervalId] = useState(null)
  const [progress, setProgress] = useState(0)
  const [showPoppup, setShowPoppup] = useState(false)
  const [text, setText] = useState<TableResumen[] | any>([])
  const [errorText, setErrorText] = useState<string>('')
  const [loadingDownload, setLoadingDownload] = useState(false)
  const fileInputRef = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [intervalId])

  const incrementProgress = () => {
    setProgress((prev: any) => (prev < 90 ? prev + 1 : prev))
  }

  const handleGetTemplate = async () => {
    try {
      setLoadingDownload(true)
      const response = (await serviceTemplate()) as any
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${title}-Plantilla.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setLoadingDownload(false)
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
    }
  }
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0]
    setFile(selectedFile || null)
    setFileName(selectedFile || null)
    setError('')
    setProgress(0)
  }

  const handleUpload = async () => {
    try {
      if (file) {
        let success = false
        const formData = new FormData()
        formData.append('test', file)
        setLoading(true)
        const interval = setInterval(incrementProgress, 500)
        setIntervalId(interval as any)
        setShowPoppup(true)
        const response = (await handleSendService(formData)) as any
        success = response?.data.error
        setLoading(false)
        if (response?.data.error) {
          const error = response?.data?.data || []
          const error1 = response?.data?.data1 || []
          const message = response?.data?.message || ''
          //response central - lavanderia
          setText(message)
          setResponse(error)
          setResponse1(error1)
          // response hoteleria
          setErrorText(message)
        }
        if (fileInputRef.current) {
          fileInputRef.current.value = ''
        }

        clearInterval(interval)

        // Iniciar el incremento final hasta 100%
        const completeInterval = setInterval(() => {
          setProgress((prev) => {
            if (prev >= 100) {
              clearInterval(completeInterval)
              setLoading(false)
              setShowPoppup(false)
              if (!success) {
                ShowSnackBar('Documento cargado correctamente')
              } else {
                setShow(true)
              }
              return prev
            }
            return prev + 1
          })
        }, 15)
        setFile(null)
      } else {
        setError('Este campo es requerido')
      }
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
      setLoading(false)
      setShowPoppup(false)
      setProgress(0)
    }
  }
  const handleClose = () => {
    setShowPoppup(false)
  }
  return (
    <KTCard shadow className='m-5'>
      <form>
        <div className='p-6'>
          <div className='row'>
            <div className='mb-12 col-sm-12 col-lg-12'>
              <Button
                onClick={handleGetTemplate}
                label='Descargar Plantilla'
                loading={loadingDownload}
              />
            </div>
            <div className='mb-2 col-sm-12 col-md-6 col-lg-4'>
              <label className='required form-label'>Examinar</label>
              <div className='input-group input-group-sm'>
                <input
                  className='form-control'
                  type='file'
                  id='formFileRoom'
                  onChange={handleFileChange}
                  ref={fileInputRef}
                />
              </div>
              {showPoppup && (
                <Poppup
                  progress={progress}
                  handleClose={handleClose}
                  text={
                    'Se está cargando la información, espere un momento mientras termine de procesar ...'
                  }
                />
              )}

              {error && <p className='error-message'>{error?.toString()}</p>}
            </div>
          </div>
        </div>
        <div className='d-flex justify-content-center mb-3'>
          <Button onClick={handleUpload} label='Subir Archivo' disabled={loading} />
        </div>
      </form>
      {showModalList ? (
        <ModalErrorList show={show} setShow={setShow} file={file} message={errorText} />
      ) : (
        <ModalErrorTable
          show={show}
          setShow={setShow}
          data={response}
          file={fileName}
          message={text}
          data1={response1}
          textData1={textData1}
          textData={textData}
        />
      )}
    </KTCard>
  )
}

export {FormMasive}
